import { makeStyles } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import { WithTranslation } from 'react-i18next';
import NavigationBar from '../../../components/NavigationBar';
import { PageTitle } from '../../../components/PageTitle/PageTitle';
import { useUniversalTracking } from '../../../lib/tracking/universalTracking';
import { ContractState } from '../../../types/redux';
import { formatIban } from '../../../utils/formatString';

const useStyles = makeStyles(() => ({
	reviewData: {
		display: 'flex',
		backgroundColor: 'white',
		flexWrap: 'wrap',
		paddingLeft: '31px',
		paddingRight: '31px',
		paddingTop: '14px',
		paddingBottom: '14px',
		justifyContent: 'flex-start',
	},
	reviewDataColumn: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		color: '#000000',
		fontSize: '13px',
		fontWeight: 500,
		letterSpacing: '0.25px',
		marginBottom: '15px',
		lineHeight: '53px',
	},

	reviewFieldHeader: {
		height: '24px',
		width: '230px',
		color: '#0463c2',
		fontSize: '11px',
		letterSpacing: '0.23px',
		lineHeight: '22px',
		fontWeight: 300,
	},
	reviewField: {
		minHeight: '34px',
		width: '230px',
		color: '#4b4b4d',
		fontFamily: 'Roboto',
		fontSize: '13px',
		letterSpacing: '0.25px',
		lineHeight: '19px',
		fontWeight: 300,
		marginBottom: '6px',
	},
}));
interface Props extends WithTranslation, StateProps, DispatchProps {
	onSubmit(data: any): void;
}

const Contact: FunctionComponent<Props> = (props) => {
	const { trackEvent } = useUniversalTracking();

	const { contract } = props;

	const classes = useStyles();

	const columnTitle = (title: string) => <div>{title}</div>;

	const formatPrice = (num: number) =>
		num.toLocaleString(['DE'], { minimumFractionDigits: 2 }) + '€';

	const formatDate = (rawDate: string) =>
		rawDate.split('-').reverse().join('.');

	const onSubmit = () => {
		trackEvent({
			category: 'review-submit',
			action: 'click-event',
			label: 'review',
		});
		props.onSubmit({});
	};

	const contact = () => (
		<>
			{reviewDataItem(props.t('review.contact'), [
				contract.vorname,
				contract.name,
				`${contract.plz} ${contract.ort}`,
				contract.strasse,
			])}
		</>
	);

	const pramie = () =>
		reviewDataItem(props.t('review.pramie'), [
			`${formatPrice(contract.beitrag)} ${contract.zahlweise}`,
		]);

	const versicherungbeginn = () =>
		reviewDataItem(props.t('review.versicherungbeginn').toUpperCase(), [
			formatDate(contract.zulassungsdatum),
		]);

	const email = () =>
		reviewDataItem(props.t('review.e-mail'), [contract.email]);

	const kontodaten = () => (
		<div className={classes.reviewDataColumn}>
			<div>{props.t('review.kontodaten')}</div>
			{reviewDataItem(props.t('review.IBAN'), [formatIban(contract.iban)])}
		</div>
	);

	const reviewDataItem = (title: string, fields: string[]) => (
		<div>
			<div className={classes.reviewFieldHeader}>{title}</div>
			<div className={classes.reviewField}>
				{fields.map((field, index) => (
					<div key={index}>{field}</div>
				))}
			</div>
		</div>
	);

	const renderColumns = (column: 1 | 2) => {
		// OTHER CONTRACTS
		if (column === 1) {
			return (
				<>
					<div className={classes.reviewDataColumn}>
						{columnTitle(props.t('review.vertragsdaten'))}
						{versicherungbeginn()}
						{pramie()}
					</div>
					{kontodaten()}
				</>
			);
		}
		if (column === 2) {
			return (
				<div className={classes.reviewDataColumn}>
					{columnTitle(props.t('review.kundendaten'))}
					{contact()}
					{email()}
				</div>
			);
		}

		return null;
	};

	return (
		<div>
			<PageTitle title={props.t('review.title')} />
			<div className={classes.reviewData}>
				{renderColumns(1)}
				{renderColumns(2)}
			</div>
			<NavigationBar onClickContinue={onSubmit} />
		</div>
	);
};

interface StateProps {
	contract: ContractState;
}

interface DispatchProps {}

export default Contact;
